module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN330_685285000.382b42e3.png";